import { call, put, takeLatest } from "redux-saga/effects";
import { retrieveOrderRequest, retrieveOrderSuccess, retrieveOrderFailure } from "../../slice/orderRetrieveSlice/retrieveSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
import i18n from "../../../../i18n";
const fetchOrderRetrieveData = async orderPayload => {
  const ORDER_RETRIEVE_API_URL = config.DAPI_ORDER_INSURANCE_RETRIEVE;
  const data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: true
  };
  const response = await api.post(`${ORDER_RETRIEVE_API_URL}`, orderPayload, data);
  return response;
};
function* getOrderRetrieveData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchOrderRetrieveData, payload);
    yield put(retrieveOrderSuccess(response.data));
  } catch (error) {
    yield put(retrieveOrderFailure(error));
  }
}
export function* watchOrderRetrieveData() {
  yield takeLatest(retrieveOrderRequest.type, getOrderRetrieveData);
}